import React, { useEffect, useMemo, useState } from "react";
import "./ProductImage.css";

export const PRODUCT_IMAGE_PLACEHOLDER = `${process.env.PUBLIC_URL || ""}/assets/images/rghtnow_placeholder.png`;

const INVALID_IMAGE_VALUES = new Set([
  "",
  "null",
  "undefined",
  "false",
  "0",
  "n/a",
  "na",
]);

export const isInvalidProductImage = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value !== "string") return false;

  const normalizedValue = value.trim().toLowerCase();
  if (INVALID_IMAGE_VALUES.has(normalizedValue)) return true;

  return (
    normalizedValue.startsWith("<error") ||
    (normalizedValue.includes("nosuchkey") && normalizedValue.includes("<"))
  );
};

const ProductImage = ({
  src,
  alt = "Product",
  className = "",
  fallbackSrc = PRODUCT_IMAGE_PLACEHOLDER,
  fetchPriority,
  onError,
  ...props
}) => {
  const initialSrc = useMemo(
    () => (isInvalidProductImage(src) ? fallbackSrc : src),
    [fallbackSrc, src]
  );
  const [imageSrc, setImageSrc] = useState(initialSrc);
  const [isFallback, setIsFallback] = useState(initialSrc === fallbackSrc);

  useEffect(() => {
    setImageSrc(initialSrc);
    setIsFallback(initialSrc === fallbackSrc);
  }, [fallbackSrc, initialSrc]);

  const handleError = (event) => {
    onError?.(event);

    if (imageSrc === fallbackSrc) {
      event.currentTarget.onerror = null;
      return;
    }

    setImageSrc(fallbackSrc);
    setIsFallback(true);
  };

  return (
    <img
      {...props}
      fetchpriority={fetchPriority ?? props.fetchpriority}
      src={imageSrc}
      alt={alt}
      className={`rght-product-image ${className}`.trim()}
      data-fallback-image={isFallback ? "true" : undefined}
      onError={handleError}
    />
  );
};

export default ProductImage;
